import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../imageWithBasePath";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataTheme } from "../../redux/themeSettingSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import LoginModal from "../modal/loginModal";
import RegisterModal from "../modal/registerModal";
import ForgotPasswordModal from "../modal/forgotPassword";
import ChangePasswordModal from "../modal/changePassword";
import AuthMenu from "../components/AuthMenu";
import "./headerauth.css";
import "./header.scss";

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isResponsive, setIsResponsive] = useState(false);
  const [isOffcanva, setIsOffcanva] = useState(false);
  const [isMegaMenu, setIsMegaMenu] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(null);

  const dispatch = useDispatch();
  const location = useLocation();
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const routes = all_routes;
  const isAdminPage = location.pathname === routes.admin;

  const handleDataThemeChange = (theme: string) => {
    dispatch(setDataTheme(theme));
  };

  const openSubMenu = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setOpenDropdownIndex(null);
  };

  const toggleSubMenu = (index: number) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setIsResponsive(true);
      } else {
        setIsResponsive(false);
        setIsOffcanva(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("class", dataTheme);
  }, [dataTheme]);

  const DarkButton = () => {
    return (
      <div className="me-3">
        <Link
          to="#"
          id="dark-mode-toggle"
          className={`theme-toggle ${dataTheme === "light" && "activate"}`}
          onClick={() => handleDataThemeChange("dark-mode")}
        >
          <i className="isax isax-moon" />
        </Link>
        <Link
          to="#"
          id="light-mode-toggle"
          className={`theme-toggle ${dataTheme === "dark-mode" && "activate"}`}
          onClick={() => handleDataThemeChange("light")}
        >
          <i className="isax isax-sun-1" />
        </Link>
      </div>
    );
  };

  // centered buttons in desktop header
  const HeaderCenterNav: React.FC = () => (
    <div className="header-center-nav d-none d-xl-flex">
      <Link
        to={routes.home1}
        className={`header-center-btn ${location.pathname === "/index" && !location.hash ? "active" : ""
          }`}
      >
        Home
      </Link>

      <Link
        to={`${routes.home1}#flights`}
        className={`header-center-btn ${location.pathname === "/index" && location.hash === "#flights"
          ? "active"
          : ""
          }`}
      >
        Flights
      </Link>

      <Link
        to={`${routes.home1}#hotels`}
        className={`header-center-btn ${location.pathname === "/index" && location.hash === "#hotels"
          ? "active"
          : ""
          }`}
      >
        Hotels
      </Link>
    </div>
  );


  // buttons inside offcanvas menu (mobile)
  const OffcanvasNavButtons: React.FC = () => (
    <div className="offcanvas-nav mt-3">
      <Link
        to={routes.home1}
        className="btn btn-outline-light w-100 mb-2"
        onClick={() => setIsOffcanva(false)}
      >
        Home
      </Link>
      <Link
        to={`${routes.home1}#flights`}
        className="btn btn-outline-light w-100 mb-2"
        onClick={() => setIsOffcanva(false)}
      >
        Flights
      </Link>
      <Link
        to={`${routes.home1}#hotels`}
        className="btn btn-outline-light w-100"
        onClick={() => setIsOffcanva(false)}
      >
        Hotels
      </Link>
    </div>
  );

  return (
    <>
      <div className={"main-header"}>
        {/* Header */}
        <header className={`${scrolled ? "fixed" : ""}`}>
          <div className="container">
            <div className={`offcanvas-info ${isOffcanva ? "show" : ""}`}>
              <div className="offcanvas-wrap">
                <div className="offcanvas-detail">
                  <div className="offcanvas-head">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <Link to={routes.home1} className="black-logo-responsive w-50">
                        <ImageWithBasePath src="assets/img/logo.png" alt="logo-img" />
                      </Link>
                      <Link to={routes.home1} className="white-logo-responsive w-50">
                        <ImageWithBasePath src="assets/img/logo.svg" alt="logo-img" />
                      </Link>
                      <div className="offcanvas-close" onClick={() => setIsOffcanva(false)}>
                        <i className="ti ti-x" />
                      </div>
                    </div>
                  </div>

                  {/* Home / Flights / Hotels buttons in offcanvas */}
                  {!isAdminPage && <OffcanvasNavButtons />}

                  {/* Mobile menu (collapsed) */}
                  <div className={`mobile-menu fix mb-3 ${isResponsive ? "mean-container" : ""}`}>
                    <div className="mean-bar">
                      <nav className="mean-nav">
                        <ul className="main-nav" style={{ display: "none" }}>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  {/* Offcanvas footer */}
                  <div className="offcanvas__contact">
                    <div className="mt-4">
                      {/* REPLACED Sign In 2 */}
                      <div>
                        <AuthMenu signInBtnClassName="text-white btn btn-dark w-100 mb-3" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`offcanvas-overlay ${isOffcanva ? "overlay-open" : ""}`}
              onClick={() => setIsOffcanva(false)}
            />

            <div className="header-nav">
              <div className="main-menu-wrapper">
                <div className="navbar-logo">
                  <Link className="logo-white header-logo" to={routes.home1}>
                    <ImageWithBasePath
                      src="assets/img/trio image.png"
                      className="logo"
                      alt="Logo"
                      height={136}
                      width={136}
                    />
                  </Link>

                  <Link className="logo-dark header-logo" to={routes.home1}>
                    <ImageWithBasePath
                      src="assets/img/trio image.png"
                      className="logo"
                      alt="Logo"
                      height={136}
                      width={136}
                    />
                  </Link>
                </div>

                {/* Centered Home / Flights / Hotels buttons */}
                {!isAdminPage && <HeaderCenterNav />}

                {/* RIGHT SIDE BUTTONS / VARIANTS */}
                {location.pathname === "/index" ? (
                  <div className="header-btn d-flex align-items-center">
                    {/* <DarkButton /> */}
                    <div>
                      <AuthMenu signInBtnClassName="btn btn-white me-3" />
                    </div>
                    <div className="header__hamburger d-xl-none my-auto">
                      <div className="sidebar-menu" onClick={() => setIsOffcanva(true)}>
                        <i className="isax isax-menu5" />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="header-btn d-flex align-items-center ms-auto">
                    <div>
                      <AuthMenu signInBtnClassName="btn btn-white me-3" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </header >
        {/* /Header */}
      </div >

      {/* Auth Modals */}
      <LoginModal />
      <RegisterModal />
      <ForgotPasswordModal />
      <ChangePasswordModal />
    </>
  );
};

export default Header;